import React from 'react'

export default function AdminNotFoundPage () {
  return (
    <h1>Not found</h1>
  )
}
